var productionMode = false;
var environment = 'staging';
var serverUrl = 'https://mon.qtrust.id:40013';
var serviceName = 'mpm-dashboard-staging';
var secretToken = 'PpUw5ZibLVZFORV';
const gaId = 'G-VKBL2L6LHK';
const urlStart = 'https://smpm-dash.qtrust.id'; //please change this

const urlStartLog = 'https://smpm-dash-log.qtrust.id'

export default {productionMode ,gaId ,environment ,serverUrl, serviceName, secretToken, urlStart, urlStartLog};

